import './styles.css'
import { ArrowRightOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { DispatchStorePopover } from './DispatchStorePopover'
import { BBDTag, Horizontal, Texto } from '@gravitate-js/excalibrr'

export const StoreCityStateList = ({ order, setOrderHistoryStoreId, explicitView = false }) => {
  if (!order.drops) return null
  let trimmedCity = ''
  const isBackhaul = order.type?.toLowerCase() === 'backhaul'

  if (order.drops[0].city && order.drops[0].city.trim() !== '') {
    trimmedCity = order.drops[0].city.length > 14 ? order.drops[0].city.slice(0, 15) + '...' : order.drops[0].city
  }
  const showComma = !isBackhaul && trimmedCity !== ''

  if (explicitView && order.drops.length === 1) {
    return (
      <BBDTag className='text-truncate'>
        <Horizontal verticalCenter>
          <Texto>
            <EnvironmentOutlined className='pr-2' />
            <DispatchStorePopover setOrderHistoryStoreId={setOrderHistoryStoreId} destinations={[order.drops[0]]} />
            {showComma && ' , '}
            {!isBackhaul && order.drops[0].city}
          </Texto>
        </Horizontal>
      </BBDTag>
    )
  } else if (explicitView) {
    return (
      <BBDTag className='text-truncate' textTransform='none'>
        <Horizontal verticalCenter>
          <Texto align={'left'}>
            <EnvironmentOutlined className='pr-2' />
            <DispatchStorePopover setOrderHistoryStoreId={setOrderHistoryStoreId} destinations={[order.drops[0]]} />
            <ArrowRightOutlined className='pl-2 pr-2' />
            <span>
              <DispatchStorePopover
                setOrderHistoryStoreId={setOrderHistoryStoreId}
                destinations={order.drops.length === 2 ? [order.drops[1]] : order.drops.slice(1)}
              />
            </span>
          </Texto>
        </Horizontal>
      </BBDTag>
    )
  }

  if (order.drops.length === 1) {
    return (
      <BBDTag className='dispatch-stores flex'>
        <EnvironmentOutlined className='pr-2' />
        <DispatchStorePopover setOrderHistoryStoreId={setOrderHistoryStoreId} destinations={[order.drops[0]]} />
        {showComma && ' , '}
        {!isBackhaul && <span className='ml-1'>{order.drops[0].city}</span>}
      </BBDTag>
    )
  }

  return (
    <BBDTag className='dispatch-stores flex'>
      <EnvironmentOutlined className='pr-2' />
      <DispatchStorePopover setOrderHistoryStoreId={setOrderHistoryStoreId} destinations={[order.drops[0]]} />
      <ArrowRightOutlined className='pl-2 pr-2' />
      <DispatchStorePopover
        setOrderHistoryStoreId={setOrderHistoryStoreId}
        destinations={order.drops.length === 2 ? [order.drops[1]] : order.drops.slice(1)}
      />
    </BBDTag>
  )
}
